// extracted by mini-css-extract-plugin
module.exports = {"restUsersAvatar":"RestUsersAvatar_restUsersAvatar__3SnLY","hasItemsSelected":"RestUsersAvatar_hasItemsSelected__BO38X","activeAvatar":"RestUsersAvatar_activeAvatar__v3FFm"};